const baseUrl = '/companies';
export const companiesRoutes = {
  baseUrl: "".concat(baseUrl),
  company: id => "".concat(baseUrl, "/").concat(id),
  companyTypes: "".concat(baseUrl, "/company-types"),
  companyUnits: companyId => "".concat(baseUrl, "/").concat(companyId, "/units"),
  properties: id => "".concat(baseUrl, "/").concat(id, "/properties-v2"),
  propertiesLegacy: id => "".concat(baseUrl, "/").concat(id, "/properties"),
  propertyList: companyId => "".concat(baseUrl, "/").concat(companyId, "/property-list"),
  residentAddendums: id => "".concat(baseUrl, "/").concat(id, "/residentAddendums")
};